import {DataFrameSpec} from 'data-frames/DataFrameTypes';
import {ColumnHeaderTransformOptions} from 'data-frames/header-menu/DataFrameHeaderMenuOptions';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';

/**
 * Get `DataFrameRenameColumnOptions`, used to inject logic for renaming columns into a data frame table.
 *
 * @package
 */
export default function getRenameColumnOptions(
  dataFrameSpec: DataFrameSpec,
  currentConfig: PipelineStepConfig<PipelineStepType.RENAME_COLUMNS, 0> | null,
  updateConfig: (newConfig: PipelineStepConfig<PipelineStepType.RENAME_COLUMNS, 0>) => Promise<void>,
  deleteStep: () => Promise<void>
): ColumnHeaderTransformOptions[PipelineStepType.RENAME_COLUMNS] {
  const renameColumn = (columnSystemName: string, newName?: string): Promise<void> => {
    const renamesToKeep = (currentConfig?.renameColumns ?? []).filter(
      (rename) => rename.column !== columnSystemName
    );
    const updatedRenames =
      newName && newName.length > 0
        ? [...renamesToKeep, {column: columnSystemName, name: newName}]
        : renamesToKeep;

    if (updatedRenames.length > 0) {
      return updateConfig({renameColumns: updatedRenames});
    } else {
      return deleteStep();
    }
  };

  return {renameColumn};
}
